import { jsx, jsxs } from "react/jsx-runtime";
const SvgItalic = (props) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 27 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("rect", { x: 0.5, y: 0.5, width: 25.6667, height: 25.6667, rx: 5.5, fill: "white" }),
  /* @__PURE__ */ jsx("rect", { x: 0.5, y: 0.5, width: 25.6667, height: 25.6667, rx: 5.5, stroke: "#E3DFF3" }),
  /* @__PURE__ */ jsx("path", { d: "M15.3333 18.6667H10V17.3333H11.9511L13.3617 9.33333H11.3333V8H16.6667V9.33333H14.7156L13.305 17.3333H15.3333V18.6667Z", fill: "#777777" })
] });
export default SvgItalic;
